/*import React from 'react'
function UToggleSwitch(props) {
    return (
        <div className="u_toggle-switch">
            <input type="checkbox" id={props.id} {...props} readOnly onChange={props.onChange}
                   checked={props.checked}
                   name={props.name}/>
            <label htmlFor={props.id}/>
        </div>
    )
}

UToggleSwitch.propTypes = {}

export default UToggleSwitch*/


/**
 * =========================================================================================
 * Component - Toggle Switch
 * =========================================================================================
 **/

import React from 'react';

// Packages
import PropTypes from 'prop-types';

const UToggleSwitch = (props) => {
    return (
        <React.Fragment>
            <div className={`u_toggle-switch ${props.isActive <= '01' ? 'disabled' : ''}`}>
                <input type="checkbox" id={props.id} readOnly onChange={props.onChange} checked={props.checked} disabled={props?.disabled} />
                <label htmlFor={props.id} />
                {props.label && <span>{props.label}</span>}
            </div>
        </React.Fragment>
    )
}

UToggleSwitch.propTypes = {
    id: PropTypes.string
}

export default UToggleSwitch;